import * as tslib_1 from "tslib";
import { Component, Vue, Watch } from 'vue-property-decorator';
import { env } from '@ivy/fts/envInfo/envInfo';
import { isXcxWeb } from '@ivy/fts/utils';
import * as weixin from '@ivy/fts/weixin';
import goodsSalesList from '../../comps/goodsSalesList.vue';
import ivyPlayer from '../../../commons/ivyPlayer.vue';
import goodsHeaderImg from '../../comps/goodsHeaderImg.vue';
import TitleBar from '../comps/TitleBar.vue';
import Collocation from '../../comps/collocation.vue';
import { uploadEvent } from '@/api/goods/statistics';
import RichText from '@ivy/fts/comps/RichText.vue';
import config from '@/config';
let goodsSalesDetail = class goodsSalesDetail extends Vue {
    constructor() {
        super(...arguments);
        this.spuData = {};
        this.choosedList = [];
        this.choosedMinNum = false;
        this.choosedNotMinNum = false;
        this.show = false;
        this.skuIds = [];
        this.pSkus = [];
        this.skuItems = [];
        this.noData = false;
        this.couponList = []; // 已领优惠券列表
        this.toGetCouponList = []; // 待领优惠券列表
        this.couponDiscountPrice = null;
        this.toGetCouponDiscountPrice = null;
        this.useCouponThresholdPrice = null; // 优惠券使用门槛
        this.couponDiscountTotalPrice = null; // 优惠券总优惠
        this.buyPriceInfo = {};
        this.navbarHeight = 0; // app状态栏高度
        this.isDiscount = false;
        this.isloading = true;
        this.titleBarTitle = '';
        this.isLoaded = false;
        this.tabpaneHeightList = [];
        this.windowHeight = 0;
        this.scrollHeight = 0;
        this.isFixed = false;
        this.currentIndex = 0;
        this.mLastMotionY = 0; // 上次滑动的y坐标
        this.reqId = null;
        this.tabTop = 0;
        this.listen = {};
        this.isVip = false;
        this.coverbgcolor = '#2288a6';
        this.tabpane0bottom = 0;
        this.tabpane1bottom = 0;
    }
    get list() {
        let flag_title = this.getFlagTitle(this.collocationInfo.type);
        let arr = [{ id: 0, title: flag_title }];
        this.titleBarTitle =
            this.isApp && this.isLoaded ? this.collocationInfo.title : '常青藤爸爸';
        if (this.collocationInfo.detail_info) {
            arr.push({ id: 1, title: '详情介绍' });
        }
        return arr;
    }
    get style() {
        return this.isFixed && this.isApp
            ? { top: 40 + this.navbarHeight + 'px' }
            : '';
    }
    get xcxWeb() {
        return isXcxWeb();
    }
    get totalMoney() {
        let sum = 0;
        if (this.choosedList.length > 0) {
            this.choosedList.forEach(item => {
                item.vip_price && !this.isDiscount
                    ? (sum += +item.vip_price * item.num * 100)
                    : item.discount_price !== item.price
                        ? (sum += +item.discount_price * item.num * 100)
                        : (sum += +item.price * item.num * 100);
            });
            // 当满门槛时减优惠金额
            if (sum >= this.useCouponThresholdPrice * 100) {
                sum = sum - this.couponDiscountTotalPrice * 100;
            }
            return sum / 100;
        }
        return 0;
    }
    get isApp() {
        return env.type === 'ivydad';
    }
    get showListen() {
        let listen = this.listen;
        return (this.listen &&
            !(listen.course_id === 24 && listen.auth_scope === 'all') &&
            listen.href);
    }
    async checkIsVip() {
        let info = await env.getInfo();
        let vip = false;
        if (env.type === 'ivydad') {
            vip = Boolean(+info.userInfo.isVip);
        }
        else if (env.type === 'wx') {
            vip = info.logined && info.logined.vip;
        }
        return vip;
    }
    // 临时方案，商品详情页跳转过来的需要titleBar，app直接h5跳转过来的不需要
    get needAppPay() {
        let { f_r_o_m } = this.$route.query;
        return f_r_o_m === 'goodsView';
    }
    get options() {
        return {
            title: this.collocationInfo.title,
            desc: this.collocationInfo.desc,
            content: this.collocationInfo.desc,
            pic_url: this.collocationInfo.covers && this.collocationInfo.covers[0],
            url: window.location.href,
        };
    }
    choosedListChange() {
        this.skuIds = [];
        this.pSkus = [];
        this.skuItems = [];
        this.complateChooseCondit();
        this.choosedList.forEach(item => {
            this.skuIds.push(item.sku_id);
            this.pSkus.push({
                goods_type: item.goods_type || 'goods',
                id: item.sku_id,
                num: item.num,
                sale_price: item.price,
                vip_price: item.vip_price,
                final_price: item.discount_price,
            });
            this.skuItems.push({ goodsNum: item.num, skuId: item.sku_id });
        });
        this.couponList = [];
        this.toGetCouponList = [];
        this.buyPriceInfo = [];
        if (this.choosedNotMinNum) {
            this.cancelRequest();
            console.log('clear');
        }
        else {
            this.getProcessingCoupons();
        }
    }
    async complateChooseCondit() {
        this.choosedMinNum =
            (this.choosedList.length >= 2 &&
                this.collocationInfo.type != 'personality') ||
                (this.choosedList.length >= 1 &&
                    this.collocationInfo.type == 'personality');
        this.choosedNotMinNum =
            (this.choosedList.length < 2 &&
                this.collocationInfo.type != 'personality') ||
                (this.choosedList.length < 1 &&
                    this.collocationInfo.type == 'personality');
    }
    async mounted() {
        await env.init();
        this.navbarHeight = (await env.getNavbarHeight()) - 4 || 25;
        this.spuId = this.$route.query.spuId;
        this.cid = Number(this.$route.query.cid);
        this.isVip = await this.checkIsVip();
        await this.getData();
        await this.getCollectionList();
        this.isLoaded = true;
        this.show = true;
        this.$title(this.titleBarTitle || '常青藤爸爸');
        !this.isApp && (await this.setShare());
        this.mLastMotionY =
            window.pageYOffset ||
                document.documentElement.scrollTop ||
                document.body.scrollTop; // 记录初始滑动位置
        // 搭配售埋点
        await uploadEvent.init();
        uploadEvent.sendRecord('Exposure_MatchSaleDetail', '', {
            MatchSaleID: this.collocationInfo.id,
            MatchSaleName: this.collocationInfo.title,
        }, [
            ['p1', 'MatchSaleID'],
            ['p2', 'MatchSaleName'],
        ]);
        setTimeout(() => {
            window.addEventListener('scroll', this.scrollEvent);
            if (this.list.length >= 1) {
                this.getHeight();
            }
        }, 300);
        this.coverbgcolor = this.collocationInfo.cover_bg_color || '#2288a6';
        if (this.isIOS()) {
            this.tabpane0bottom = 40 + 31;
            this.tabpane1bottom = 31;
        }
        else {
            this.tabpane0bottom = 40;
        }
        this.complateChooseCondit();
    }
    destroyed() {
        window.removeEventListener('scroll', this.scrollEvent);
    }
    async setShare() {
        let options = {
            title: this.collocationInfo.title,
            desc: this.collocationInfo.desc,
            imgUrl: this.collocationInfo.covers && this.collocationInfo.covers[0],
            link: window.location.href,
        };
        await weixin.weixinShare(options);
    }
    async getCollectionList() {
        let params = null;
        if (this.$route.query.is_preview) {
            params = {
                skuId: this.$route.query.skuId,
                is_preview: 1,
            };
        }
        else {
            params = {
                skuId: this.$route.query.skuId,
            };
        }
        let { data } = await this.$axios.get('/api/goods/shop/search/collocation/getCollocationListIter', // 搭配购列表
        {
            params,
        });
        this.collocationList = data.filter(item => item.id !== this.cid);
    }
    async getData() {
        let params = null;
        if (this.$route.query.is_preview) {
            params = {
                collocation_id: this.cid,
                is_preview: 1,
            };
        }
        else {
            params = {
                collocation_id: this.cid,
            };
        }
        let data = await this.$axios.get(`/api/goods/shop/search/collocation/getCollocationInfo`, // 搭配购详情
        {
            params,
        });
        if (data.status === 200) {
            Object.keys(data.data).length === 0
                ? (this.noData = true)
                : (this.noData = false);
            this.collocationInfo = data.data;
            this.collocationInfo &&
                this.collocationInfo.goods_list &&
                this.collocationInfo.goods_list.map(item => (item.isopen = false));
            this.spuData = data.data;
            this.spuData.cover_pics = data.data.covers;
        }
        if (['stable', 'personality'].includes(this.collocationInfo.type)) {
            this.choosedList = this.collocationInfo.goods_list;
        }
        this.isDiscount = this.collocationInfo.preferential_type !== 'none';
        this.couponList = this.collocationInfo.get_coupons || [];
        this.toGetCouponList = this.collocationInfo.to_get_coupons || [];
        this.buyPriceInfo = this.collocationInfo.buy_price_info || [];
    }
    async toDetail(val) {
        this.cid = val;
        let paramObj = Object.assign(this.$route.query, { cid: this.cid });
        let params = '';
        for (let k in paramObj) {
            params += paramObj[k] ? `${k}=${paramObj[k]}&` : '';
        }
        window.location.href = `${window.origin}/goods/goodsSalesDetail?${params}`;
    }
    async choose(item) {
        if (['stable', 'personality'].includes(this.collocationInfo.type))
            return;
        if (!item.is_stock)
            return;
        await env.init();
        const isLogin = await env.getIsLogin();
        if (!isLogin) {
            // 用户未注册
            return await env.login();
        }
        const index = this.choosedList.indexOf(item);
        if (index > -1) {
            this.choosedList.splice(index, 1);
        }
        else {
            this.choosedList.push(item);
        }
    }
    getHeight() {
        const tabs = this.$refs.tabs;
        if (tabs) {
            this.tabTop = tabs.offsetTop;
        }
        this.list.forEach((item, index) => {
            const tabpane = this.$refs[`tabpane-${item.id}`];
            if (tabpane && tabs) {
                this.tabpaneHeightList.push(tabpane.offsetTop - tabs.offsetHeight);
            }
        });
        return this.tabpaneHeightList;
    }
    currentIndexChange(index) {
        this.tabpaneHeightList = [];
        this.getHeight();
        if (this.currentIndex == index) {
            return;
        }
        this.currentIndex = index;
        this.$nextTick(() => {
            let tabpane0 = this.$el.querySelector('.tabpane-0').classList;
            let tabpane1 = this.$el.querySelector('.tabpane-1').classList;
            this.$el.querySelector('.tabpane-1').classList;
            if (this.currentIndex === 0) {
                tabpane0.remove('noactive');
                tabpane0.add('active');
                tabpane1.remove('active');
                tabpane1.add('noactive');
            }
            else if (this.currentIndex === 1) {
                tabpane0.remove('active');
                tabpane0.add('noactive');
                tabpane1.remove('noactive');
                tabpane1.add('active');
            }
        });
    }
    scrollStep(s) {
        document.documentElement.scrollTop = document.body.scrollTop = s;
    }
    doScroll(tabS) {
        let canScrollTop = document.documentElement.scrollHeight -
            document.documentElement.offsetHeight;
        tabS = Math.min(tabS, canScrollTop);
        let c = document.documentElement.scrollTop || document.body.scrollTop;
        console.log('当前滚动距离', c);
        console.log('需要滚动距离', tabS);
        const self = this;
        let addOnce = true;
        this.reqId && cancelAnimationFrame(this.reqId);
        this.reqId = window.requestAnimationFrame(() => {
            ;
            (function scrollFn(t, c, p) {
                let r = Date.now() - t;
                if (r <= 500) {
                    // 保证在500ms内完成滚动
                    var step = (function (e, t, n, a) {
                        var l = n - t;
                        let ddd = (e /= a / 2);
                        if (ddd < 1) {
                            return (l / 2) * e * e + c; // 时间为e，初始位置c,加速为1时的位移(滚动距离)
                        }
                        else {
                            return (-l / 2) * (--e * (e - 2) - 1) + t;
                        }
                    })(r, c, p, 500);
                    self.scrollStep(step);
                    window.requestAnimationFrame(function () {
                        scrollFn(t, c, p);
                    });
                }
                else if (c < tabS && addOnce) {
                    addOnce = false;
                    self.scrollStep(tabS);
                }
            })(Date.now(), c, tabS);
        });
    }
    async scrollEvent() {
        this.windowHeight =
            document.documentElement.clientHeight || document.body.clientHeight;
        this.scrollHeight =
            document.body.scrollHeight || document.documentElement.scrollHeight;
        let scrollTop = window.pageYOffset ||
            document.documentElement.scrollTop ||
            document.body.scrollTop;
        if (this.isApp) {
            scrollTop += this.navbarHeight + 42;
        }
        // let zinde = (this.$el.querySelector('.sales-detail_content_new-tabpane') as HTMLElement).style.zIndex = 3
        // console.log('The z-index of the div is:', zinde);
        scrollTop >= this.tabTop ? (this.isFixed = true) : (this.isFixed = false);
        this.tabpaneHeightList.map((item, i) => {
            const min = i === 0 ? 0 : item;
            const max = i === this.tabpaneHeightList.length - 1
                ? null
                : this.tabpaneHeightList[i + 1];
            if (scrollTop + 3 >= min && (scrollTop - 3 <= max || max === null)) {
                let old = this.currentIndex;
                // this.currentIndex = i
            }
        });
        if (scrollTop + this.windowHeight >= this.scrollHeight) {
            //滑动到底时，防止最后的tab不够满屏
            // this.currentIndex = this.list.length - 1
        }
        // ios防过冲问题
        if (this.isIOS() && this.isApp) {
            if (scrollTop - (this.navbarHeight + 42) > 0) {
                ;
                document.querySelector('.sales-detail').style.position = 'relative';
            }
            else if (scrollTop - (this.navbarHeight + 42) <= 0) {
                ;
                document.querySelector('.sales-detail').style.position = 'fixed';
            }
        }
        else {
            ;
            document.querySelector('.sales-detail').style.position =
                'relative';
        }
    }
    async confirm() {
        if (this.choosedNotMinNum)
            return;
        let { type, channel_id, receiver_id, ignoreDiscount, application, invitation, channel_activity, gift_activity, } = this.$route.query;
        if (this.isApp) {
            await env.init();
            const isLogin = await env.getIsLogin();
            if (!isLogin) {
                // 用户未注册
                return await env.login();
            }
        }
        await uploadEvent.init();
        // 立即购买埋点
        uploadEvent.sendRecord('Click_MatchSaleDetail_Buy', '', {
            MatchSaleID: this.collocationInfo.id,
            MatchSaleName: this.collocationInfo.title,
        }, [
            ['p1', 'MatchSaleID'],
            ['p2', 'MatchSaleName'],
        ]);
        let { data } = await this.$axios.get(`/api/goods/shop/search/collocation/isActivityWorking`, // 搭配购是否还可购买
        {
            params: {
                cid: this.cid,
                sku_ids: this.skuIds,
            },
        });
        if (data.valid) {
            if (this.isApp) {
                // 是否在app内
                let path = 'pages/new-goods-confirm-collocation/index.js';
                let confirmInfo = {
                    courseTitle: this.spuData.title,
                    from: 'product-details-page',
                    type: type || 'goods',
                    pageFrom: '搭配售详情页',
                    skus: this.skuItems,
                    cid: this.cid,
                    channelActivity: channel_activity,
                    giftActivity: gift_activity,
                };
                let info = {
                    path: path,
                    confirmInfo: confirmInfo,
                };
                await env.openCollocationConfirm(info);
            }
            else {
                this.$router.push({
                    path: `/orderConfirm`,
                    query: {
                        spuId: this.spuId,
                        skuId: this.skuIds,
                        channel_id: channel_id,
                        channel_activity: channel_activity,
                        gift_activity: gift_activity,
                        type: type || 'goods',
                        ignoreDiscount: ignoreDiscount,
                        application: application + '',
                        receiver_id: receiver_id,
                        invitation: invitation,
                        goodType: 'true',
                        cid: this.cid,
                        user_price: this.totalMoney + '',
                    },
                });
            }
        }
        else {
            let r = await this.$MessageBox(data.message);
            if (r === 'confirm') {
                this.show = false;
                this.choosedList = [];
                await this.getData();
                this.show = true;
            }
        }
    }
    async getProcessingCoupons() {
        await this.$axios
            .post(`/api/goods/shop/search/collocation/getCollocationCouponV2`, {
            cid: this.cid,
            pSkus: this.pSkus,
        })
            .then(res => {
            this.couponList = res.data.enable_coupons || [];
            this.toGetCouponList = res.data.to_get_coupons || [];
            this.buyPriceInfo = res.data.buy_price_info || [];
            let selectedCouponList = this.couponList &&
                this.couponList.filter(c => c.id == this.buyPriceInfo.selected_coupon_id);
            if (selectedCouponList.length > 0) {
                this.useCouponThresholdPrice = selectedCouponList.reduce((e, d) => {
                    return e + +d.threshold_price;
                }, 0);
                this.couponDiscountTotalPrice = selectedCouponList.reduce((a, b) => {
                    return a + +b.discount_price;
                }, 0);
            }
            else {
                let selectedToGetCouponList = this.toGetCouponList &&
                    this.toGetCouponList.filter(c => c.id == this.buyPriceInfo.selected_coupon_id);
                if (selectedToGetCouponList.length > 0) {
                    this.useCouponThresholdPrice = selectedToGetCouponList.reduce((e, d) => {
                        return e + +d.threshold_price;
                    }, 0);
                    this.couponDiscountTotalPrice = selectedToGetCouponList.reduce((a, b) => {
                        return a + +b.discount_price;
                    }, 0);
                }
            }
        })
            .catch(err => {
            console.log('获取优惠券失败：', err);
        });
    }
    cancelRequest() {
        if (typeof this.source === 'function') {
            this.source('终止请求');
        }
    }
    getImg(i) {
        if (i.isopen)
            return require('../images/icon-up.png');
        return require('../images/icon-down.png');
    }
    openChange(i) {
        i.isopen = !i.isopen;
    }
    async toGoodsDetail(item) {
        // 产品需求，这个活动id的商品不可进入商详页
        const banCid = config.env === 'production' ? 164 : 203;
        if (this.cid === banCid) {
            return;
        }
        if (this.isApp && !this.needAppPay) {
            let goodsUrl = `${window.location.origin}/goods/goodsView?spuId=${item.spu_id}&navBarHide=1`;
            await env.init();
            await env.commonJump(`ivydadreadtool://h5?url=${encodeURIComponent(goodsUrl)}`);
        }
        else {
            //判断是否是预览
            let query = null;
            if (this.$route.query.is_preview) {
                query = {
                    spuId: item.spu_id,
                    skuId: item.sku_id,
                    channel_id: this.$route.query.channel_id,
                    useRouterBack: 'true',
                    is_preview: this.$route.query.is_preview,
                };
            }
            else {
                query = {
                    spuId: item.spu_id,
                    skuId: item.sku_id,
                    channel_id: this.$route.query.channel_id,
                    useRouterBack: 'true',
                };
            }
            this.$router.push({
                path: '/goodsView',
                query,
            });
        }
    }
    // 试听
    async toCourse(item) {
        console.log(this.$route.query.listen, this.$route.query, item);
        this.listen = item.virtual_info[0];
        if (this.listen) {
            if (env.type === 'ivydad') {
                //App端
                await env.init();
                let options = {
                    course_type: this.listen.virtual_type,
                    content_type: this.listen.content_type,
                    from: 'product-details-page',
                    id: this.listen.course_id,
                };
                await this.$emit('intellect-statistics', 'stay');
                await env.toCourseAudition(options);
            }
            else {
                let listenHref = this.listen.href;
                listenHref = this.xcxWeb
                    ? listenHref.replace('http:', 'https:').replace('/age3?', '/age3/?')
                    : this.listen.href;
                let spuId = item.spu_id;
                console.log(listenHref, 'listenHref==========>', `${listenHref}&try_listen=1&spuId=${spuId}`);
                // 这里sentry报了一个异常
                window.location.href = `${listenHref}&try_listen=1&spuId=${this.$route.query.spuId}`;
            }
        }
    }
    getFlagTitle(type) {
        let types = {
            free: '包含内容',
            stable: '包含内容',
            personality: '包含内容',
        };
        return types[type] || null;
    }
    // 滑动背景 start
    created() {
        this.source = {
            client: {
                x: Number,
                y: Number,
            },
        };
    }
    isIOS() {
        return /iPad|iPhone|iPod/.test(navigator.userAgent);
    }
};
tslib_1.__decorate([
    Watch('choosedList')
], goodsSalesDetail.prototype, "choosedListChange", null);
goodsSalesDetail = tslib_1.__decorate([
    Component({
        components: {
            goodsHeaderImg,
            goodsSalesList,
            ivyPlayer,
            TitleBar,
            Collocation,
            RichText,
        },
        filters: {
            removeTrailingZeros(value) {
                const number = parseFloat(value);
                return number === Math.floor(number) ? Math.floor(number) : number;
            },
        },
    })
], goodsSalesDetail);
export default goodsSalesDetail;
